export const infraTec = [
    [
        { name: "Número de computadoras por funcionario judicial", tam: 1 },
        { name: "Servidores en órganos jurisdiccionales y administrativos por poder judicial", tam: 1 },
    ]
];